module.exports = __webpack_public_path__ + "static/media/faq-icon6.0a421637.png";